import { useParams } from "react-router-dom";
import OrderDetails from "../components/OrderDetails";
import useChatrooms from "../store/chatrooms";
import { useOrders } from "../store/orders";

export default function ActiveOrderDetailPage() {
	const routerParams = useParams();
	const { orders } = useOrders(); 
	const chatroom = useChatrooms(
		(state) => state.chatrooms[routerParams.orderKey!]
	);

	const order = orders[routerParams.orderKey!];
	const hasNewMessage = chatroom ? !chatroom.hasBeenReadByParticipant : false;

	return OrderDetails({ order, mode: 'active-order', hasNewMessage });

}